import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Uppy from 'uppy/lib/core';
import Transloadit from 'uppy/lib/plugins/Transloadit';
import DashboardModal from 'uppy/lib/react/DashboardModal';
import 'uppy/dist/uppy.min.css';

import TransloaditKeys from '../../config/uploadKeys';
import Button from './Button';
import AvatarImage from './AvatarImage';
import './AvatarField.css';

class AvatarField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      // Store uppy in state because it has bugs when unmounting in React if declared as a singleton
      uppy: Uppy({ debug: process.env.NODE_ENV === 'development', autoProceed: false })
        .use(Transloadit, {
          params: {
            auth: {
              // To avoid tampering use signatures:
              // https://transloadit.com/docs/api-docs/#authentication
              key: TransloaditKeys.AccountKey,
            },
            template_id: TransloaditKeys.ImageUploadTemplateId,
          },
          waitForEncoding: true,
        })
        // .use(Uppy.Webcam, { target: Uppy.Dashboard })
        // .use(Uppy.Instagram, { target: Uppy.Dashboard, host: 'https://api2.transloadit.com/uppy-server' })
        .on('transloadit:complete', (assembly) => {
          const newPath = assembly.results[TransloaditKeys.PenultimateStep][0].ssl_url.replace(
            TransloaditKeys.S3BucketUrl,
            ''
          );

          props.onSuccess(newPath);

          setTimeout(() => {
            this.setState({ isModalOpen: false });
          }, 500);
        }),
    };
  }

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    return (
      <div className="avatarUploader">
        <AvatarImage />
        <Button
          label="Upload New Profile Pic"
          size="small"
          handler={this.handleModalOpen}
          id="uppy-open-modal"
          className="is-outlined avatarUploader-button"
        />
        <DashboardModal
          uppy={this.state.uppy}
          open={this.state.isModalOpen}
          closeModalOnClickOutside
          onRequestClose={this.handleModalClose}
          proudlyDisplayPoweredByUppy={false}
        />
      </div>
    );
  }
}

AvatarField.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default AvatarField;



// WEBPACK FOOTER //
// ./src/components/common/AvatarField.jsx